import { api } from "./api";

// Usage metering. Costs are server-authoritative; the client only reads
// summaries and (for the signed-in user) records actions by name.

export const getUsageCatalog = async () => {
  const { data } = await api.get("/api/metering/catalog");
  return data;
};

// Record a billable action for the current user. Returns the charge (if any)
// and a fresh summary. Fire-and-forget friendly — never blocks the UX.
export const recordUsage = async (action, qty = 1, context = {}) => {
  const { data } = await api.post("/api/metering/record", { action, qty, context });
  return data;
};

export const getMyUsage = async () => {
  const { data } = await api.get("/api/metering/summary");
  return data;
};

// Admin.
export const getClientUsage = async (uid) => {
  const { data } = await api.get(`/api/metering/summary/${uid}`);
  return data;
};

export const getClientOverage = async (uid) => {
  const { data } = await api.get(`/api/metering/overage/${uid}`);
  return data;
};

export const createOverageInvoice = async (uid, memo) => {
  const { data } = await api.post("/api/metering/create-overage-invoice", { uid, memo });
  return data;
};

export const setClientAllowance = async (uid, allowance) => {
  const { data } = await api.post("/api/metering/set-allowance", { uid, allowance });
  return data;
};
